import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom";
import NotFound from "../../features/errors/NotFound";
import ServerError from "../../features/errors/ServerError";
import Customer from "../../features/customer/Index";
import Product from "../../features/product/Index";
import Cart from "../../features/cart/Index";
import Profile from "../../features/account/Index";
import Order from "../../features/order/Index";
import RequireAuth from "./RequireAuth";
import DashboardLayout from "../layout/Dashboard";
import AuthLayout from "../layout/Auth";
import ForgotPasswordPage from "../layout/Auth/ForgotPassword";
import Root from "../layout/Root";
import CheckoutPage from "../../features/checkout";
import OrderDetails from "../../features/orderStatus"; // order status
import CheckLoginStatus from "../../features/CheckLoginStatus";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Root />,
    children: [
      {
        index: true,
        element: <CheckLoginStatus />,
      },
      {
        element: <DashboardLayout />,
        children: [
          {
            element: <RequireAuth />,
            children: [
              { path: "customer", element: <Customer /> },
              { path: "cart", element: <Cart /> },
              { path: "dashboard", element: <Product /> },
              { path: "profile", element: <Profile /> },
              {
                path: "order",
                children: [
                  { index: true, element: <Order /> },
                  { path: ":orderId", element: <OrderDetails /> },
                ],
              },
              { path: "checkout", element: <CheckoutPage /> },
            ],
          },

          { path: "not-found", element: <NotFound /> },
          { path: "server-error", element: <ServerError /> },
          { path: "*", element: <Navigate replace to="/not-found" /> },
        ],
      },
      { path: "login", element: <AuthLayout /> },
      { path: "forgot-password", element: <ForgotPasswordPage /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
